import { Divider as AntdDivider } from 'antd';
import { FC } from 'react';
import { theme } from '../../consts/theme';

export const Divider: FC = ({ children }) => {
  return <AntdDivider style={{ color: theme.colors.dark, fontSize: 16, padding: '8px 0' }}>{children}</AntdDivider>;
};
